<template>
	<b-navbar ref="nav" toggleable="lg" type="light">
		<router-link class="navbar-brand" to="/">
			<img
				ref="logo"
				:src="logoBaseOnWidth"
				alt="Biuro Rachunkowe Joanna Macikowska Sulechów"
				title="Biuro Rachunkowe Joanna Macikowska Sulechów"
				:class="logoClass"
				tag="b-navbar-brand"
			/>
		</router-link>

		<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
		<b-collapse id="nav-collapse" is-nav class="nav-contener">
			<b-navbar-nav>
				<li
					class="nav-item"
					v-for="(link, index) in menuLinks"
					:key="index"
				>
					<router-link
						class="nav-link"
						:to="link.href"
						:href="link.href"
					>
						{{ link.label }}
					</router-link>
				</li>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
	<!-- <nav class="navbar navbar-expand-lg">
		<button
			class="navbar-toggler"
			type="button"
			data-toggle="collapse"
			data-target="#navbarNavAltMarkup"
			aria-controls="navbarNavAltMarkup"
			aria-expanded="false"
			aria-label="Toggle navigation"
		>
			<span class="navbar-toggler-icon"></span>
		</button>
		<div
			class="collapse navbar-collapse nav-contener"
			id="navbarNavAltMarkup"
		></div>
	</nav> -->
</template>

<script>
const logoNarrow = require('../assets/nazwa_black.png')
const logoWide = require('../assets/logo-wide.jpeg')
import { menuLinks } from '../shared/menu-provider'
export default {
	data: function() {
		return {
			viewWidth: 0,
			logoUrl: logoWide,
			logoClass: [],
			height: 0,
		}
	},
	methods: {
		load() {
			this.height = this.$refs.nav.clientHeight
		},
		getMenuHeight() {
			return this.height
		},
		reactOnWindowResize() {
			this.viewWidth = event.target.innerWidth
		},
	},
	watch: {
		height(val) {
			this.$emit('nav-height', val)
		},
	},
	computed: {
		logoBaseOnWidth() {
			return this.viewWidth <= 992 ? logoNarrow : logoWide
		},
		menuLinks,
	},
	mounted() {
		this.$nextTick().then(() => {
			this.$refs.logo.onload = this.load
			window.addEventListener('resize', this.reactOnWindowResize)
			this.viewWidth = window.innerWidth
		})
	},
}
</script>

<style lang="scss">
@include media-breakpoint-up(xs) {
	.navbar {
		overflow: hidden;
		width: 100%;
		// position: relative !important;
		top: 0;
		z-index: 100;
		background: #fff;
		color: $main-color;
		a {
			color: $main-color;
		}
		a:hover {
			color: $main-dark;
		}
	}

	.navbar-brand {
		img {
			transition: all 0.3s linear;
			width: 10em;
			height: auto;
		}
	}
	.nav-contener {
		@include d-flex-row-center-center;
	}
	.nav-link {
		position: relative;
		&:hover,
		&.menu-active {
			&::before {
				content: '';
				position: absolute;
				border-bottom: 1px solid $main-color;
				animation: expand-line 0.5s linear;
				width: 100%;
				bottom: 0;
				background: $main-color;
				box-sizing: border-box;
			}
		}
	}
}

@keyframes expand-line {
	0% {
		width: 0;
		height: 0;
	}
	100% {
		width: 100%;
	}
}
@include media-breakpoint-up(lg) {
	.navbar {
		padding: 0 1rem !important;
	}

	.nav-item {
		margin: 0 2rem;
	}
	.nav-contener {
		@include d-flex-row-right-center;
	}
	.navbar-brand {
		display: block !important;
		position: relative;
		img {
			width: auto;
			height: 5em;
		}
	}
}
</style>
